import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './components/search/search.component';
import { SpcComponent } from './components/spc/spc.component';
import { NavigationHeaderComponent } from './components/navigation-header/navigation-header.component';
import '@shui/core/sh-page';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, SearchComponent, SpcComponent, NavigationHeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent {
  activeTab = 0;

  constructor(private router: Router) {}

  onTabChange(index: number): void {
    this.activeTab = index;
  }

  shouldShowHeader(): boolean {
    // Show header only when not on login or callback pages
    return !this.router.url.includes('login') && !this.router.url.includes('callback');
  }
}
